import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Paper,
  ListItem,
  List,
  ListItemButton,
  ListItemIcon,
  Box,
  ListItemText
} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';

import { useConnections } from 'hooks/useConnections';
import { renderLabelName } from 'utils/getLabelConnectors';
import useConnectionStore from '../../store/useConnectors';
import Excel from 'assets/images/auth/excel.png';
import SGBuildex from 'assets/images/auth/sgbuildex_result.webp';
import Autodesk from 'assets/images/auth/autodesk.webp';
import { useMemo, useRef } from 'react';

const addedConnectors = [
  { img: Excel, label: 'Excel', provider: 'excel', id: 998 },
  { img: Excel, label: 'ETS', provider: 'ets', id: 999 },
];


export default function ListConnectorsDialog({ module, open, onConfirm, onCancel }) {
  const fileInputRef = useRef(null);
  const dataConnect = useRef(null);
  const { data: dataConnection = [], isFetching: isLoadingConnection, isError } = useConnections();
  const listConnectors = useMemo(() => {
    const data = [...dataConnection, ...addedConnectors];
  
    const extractionProviders = new Set([
      'autodesk',
      'excel',
      'googledrive',
      'ets',
      "sgbuildex"
    ]);
  
    const excludedLoadProviders = new Set([
      'excel',
      'ets',
      'googledrive'
    ]);
  
    switch (module) {
      case 'extraction':
        return data.filter((item) =>
          extractionProviders.has(item?.provider)
        );
  
      case 'loads':
        return data.filter((item) =>
          !excludedLoadProviders.has(item?.provider)
        );
  
      default:
        return data;
    }
  }, [module, dataConnection, addedConnectors]);
  const { setActiveConnection } = useConnectionStore();

  const handleSelectConnection = (data) => {
    // console.log(data);
    if (data.provider === 'excel') {
      fileInputRef.current.click();
      dataConnect.current = data;
    } else if (data.provider === 'ets') {
      fileInputRef.current.click();
      dataConnect.current = data;
    } else {
      setActiveConnection(data);
      onConfirm(data);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const data = {
      ...dataConnect.current,
      file: file
    };
    onConfirm(data);
    // console.log("Selected file:", file);
  };

  return (
    <>
      <Dialog maxWidth="xs" fullWidth open={open} onClose={onCancel}>
        <DialogTitle id="alert-dialog-title">Select Connectors</DialogTitle>
        <DialogContent>
          <List sx={{ px: 1 }}>
            {listConnectors?.map((item, index) => (
              <Paper
                key={index}
                elevation={0}
                sx={{
                  mb: 1.2,
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  '&:hover': {
                    boxShadow: 2,
                    borderColor: 'primary.main',
                    cursor: 'pointer'
                  }
                }}
              >
                <ListItem disablePadding>
                  <ListItemButton onClick={() => handleSelectConnection(item)} sx={{ py: 1.5, px: 2 }}>
                    <ListItemIcon sx={{ minWidth: 44 }}>
                      <Box component="img" src={item.img} alt={item.label} sx={{ width: 32, height: 32, objectFit: 'contain' }} />
                    </ListItemIcon>

                    <ListItemText
                      primary={renderLabelName(item)}
                      secondary="Click to connect"
                      primaryTypographyProps={{ fontWeight: 'bold' }}
                      secondaryTypographyProps={{ fontSize: 12 }}
                    />

                    <LinkIcon color="action" />
                  </ListItemButton>
                </ListItem>
              </Paper>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleCloseExtraction}>Disagree</Button> */}
          <Button onClick={onCancel} autoFocus>
            CANCEL
          </Button>
        </DialogActions>
      </Dialog>
      {/* Hidden file input */}
      <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} />
    </>
  );
}
